import React from 'react';
import StoreSummaryPage from '../features/storeSummary/pages/StoreSummaryPage';

const StoreSummary: React.FC = () => <StoreSummaryPage />;

export default StoreSummary;
